/* eslint-disable valid-jsdoc */

'use strict';

const recommendationsLogic = require('../components/recommendations');
const scrollAnimate = require('base/components/scrollAnimate');
/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
* Toggles the visibility of the reset filters button based on the number of selected filters.
* If there is more than one selected filter, the reset button is shown; otherwise, it is hidden.
*/
function toggleResetFilters() {
    let $selectedFilters = $('#refinements-popup .selected-filter-values').children();
    let $resetFilters = $('#refinements-popup .current-filters button.reset');

    $resetFilters.toggleClass('d-none', $selectedFilters.length < 2);
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    let $activeFilters = $('#refinements-popup .refinement.active');

    toggleResetFilters();
    // get active filters from current dom and apply them to new one
    $activeFilters.each(function () {
        $(this).removeClass('active');
        let classNames = $(this)[0].className;
        let classes = classNames.split(' ').map(function (className) {
            return '[class*="' + className + '"]';
        }).join('');
        let activeDiv = $results.find(classes);
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
        activeDiv.find('.icon').removeClass('icon-chevron-down').addClass('icon-chevron-up');
    });

    updateDom($results, '.refinements');
}

/**
 *
 * @param {*} url url
 */
function updateUrlParams(url) {
    let baseUrl = window.location.href;

    // Remove final '/' and current params
    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
    if (baseUrl.indexOf('?') !== -1) baseUrl = baseUrl.split('?')[0];
    // eslint-disable-next-line no-restricted-globals
    history.replaceState(undefined, '', baseUrl);

    // Get current category
    let lastSegment = baseUrl.endsWith('/') ? baseUrl.slice(0, -1).split('/').pop() : baseUrl.split('/').pop();
    if (lastSegment.indexOf('?') !== -1) lastSegment = lastSegment.split('?')[0];

    // Get search params
    const newUrl = new URL(url, baseUrl);
    let params = new URLSearchParams(newUrl.search);
    let searchParams = new URLSearchParams(params);

    if (searchParams.has('sz') && searchParams.has('start')) {
        searchParams.set('sz', parseInt(searchParams.get('start'), 10) + parseInt(searchParams.get('sz'), 10));
        searchParams.set('start', 0);
    }

    // Push search params to URL
    let pageUrl = searchParams.values().next().value !== undefined ? '?' + searchParams : '';
    // eslint-disable-next-line no-restricted-globals
    history.pushState(undefined, '', pageUrl);
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response, isFilterSelection) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    let elementsToUpdate = [
        '.current-filters',
        '.btn-refine'
    ];

    if (!isFilterSelection) {
        elementsToUpdate.push('.grid-header');
        elementsToUpdate.push('.header-bar');
        elementsToUpdate.push('.header.page-title');
        elementsToUpdate.push('.product-grid');
        elementsToUpdate.push('.show-more');
        elementsToUpdate.push('.display-refinements');
        elementsToUpdate.push('.desktop-display-refinements');
        elementsToUpdate.push('.sticky-display-refinements');
    }
    // Update DOM elements that do not require special handling
    elementsToUpdate.forEach(function (selector) {
        updateDom($results, selector);
    });

    // Update DOM elements that require special handling
    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Update show less data url from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateShowLessUrl(response) {
    var $tempDom = $('<div>').append($(response));
    var showLessUrl = $tempDom.find('.show-less-url').attr('data-url');

    var showLessButton = $('.container').find('.show-less-button-wrapper button');
    showLessButton.attr('data-url', showLessUrl);

    if (showLessButton.attr('data-url')) {
        showLessButton.removeClass('d-none');
    } else {
        showLessButton.addClass('d-none');
    }
}

/**
 * Updates articles from Ajax response
 * Removes the last n elements from product grid
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateGrid(response) {
    var $tempDom = $('<div>').append($(response));
    var $grid = $('.container .product-grid');

    $tempDom.find('.grid-footer').remove();
    $grid.prepend($tempDom.html());
}

/**
* Updates the browser's history state based on changes in the grid view.
* This function extracts a permalink from the response and updates the URL parameters accordingly.
*
* @param {Object} response - The AJAX response object containing the updated grid content.
*/
function updateHistoryOnGridChange(response) {
    let $currentLink = $(response).find('.permalink');

    if ($currentLink) {
        updateUrlParams($currentLink.val());
    }
}

// Show more products
/**
 * This function was initially overloaded in order to use the .attr() to get the updated data-url
 * So .attr() will get the data from the current HTML code, as we changed the data-url value to also consider Page Designer tiles on PLP
 * Updates .attr() for show less on each show more Ajax call.
 * Contrariwise, the .data() method was getting the data-url from the internal cache, not taking into account our changes (no DOM manipulation)
 */
function showMore() {
    $('.container').on('click', '.more-button-wrapper button', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var encodedUrl = $(this).attr('data-cbo'); // replaced .data() with .attr()
        var showMoreUrl = decodeURIComponent(window.atob(encodedUrl));
        $.spinner().start();
        $(this).trigger('search:showMore', e);
        $.ajax({
            url: showMoreUrl,
            data: {
                selectedUrl: showMoreUrl
            },
            method: 'GET',
            success: function (response) {
                $('.grid-footer').replaceWith(response);
                updateShowLessUrl(response);
                updateSortOptions(response);
                updateHistoryOnGridChange(response);
                $.spinner().stop();
                hoverImage();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
}

// Show less products
/**
 * Function overloaded in order to use the .attr() to get the updated data-url
 * So .attr() will get the data from the current HTML code, as we changed the data-url value to also consider Page Designer tiles on PLP
 * Contrariwise, the .data() method was getting the data-url from the internal cache, not taking into account our changes (no DOM manipulation)
 */
function showLess() {
    $('.show-less-button-wrapper').on('click', 'button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        var showLessUrl = $(this).attr('data-url');

        if ($('.product-grid').length > 0) {
            $.spinner().start();
            $(this).trigger('search:showLess', e);
            $.ajax({
                url: showLessUrl,
                data: {
                    selectedUrl: showLessUrl
                },
                method: 'GET',
                success: function (response) {
                    updateGrid(response);
                    updateShowLessUrl(response);
                    updateSortOptions(response);
                    updateHistoryOnGridChange(response);
                    hoverImage();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
}

/**
* Activates the sorting of the given element
* @param {Object} current - the element to be sorted
*/
function activateSorting(current) {
    $('.sort-values').find('.icon-circle-solid').removeClass('icon-circle-solid').addClass('icon-circle');
    $(current).find('.icon').addClass('icon-circle-solid').removeClass('icon-circle');

    window.$filterResponse.find('.sort-values').html($('.sort-values').html());
}

/**
* Updates the sorting rule URL and filters' URLs based on the current sorting rule
* @param {HTMLElement} current - the current sorting rule HTML element
* @returns {void}
*/
function updateSortingRuleURL(current) {
    let url = $(current).data('href');
    let searchParams = new URLSearchParams(url);
    const sruleValue = searchParams.get('srule');
    // update values of the srule parameter for filters

    let filtersButtons = $('#refinements-popup .filter-btn, #refinements-popup .selected-filter-values .btn');

    filtersButtons.each(function () {
        let filterUrl = $(this).data('href');
        let filterURL = new URLSearchParams(filterUrl);
        filterURL.set('srule', sruleValue);
        $(this).data('href', decodeURIComponent(filterURL));
    });
}

// Hover Image
/**
 * Search to see for each element if there is an hover image different of th original image too prevent double load of an image
 */
function hoverImage() {
    $(window).ready(function () {
        let $hoverImg = $('.image-container').find('.tile-hover-image');
        Array.prototype.forEach.call($hoverImg, element => {
            if (element.dataset.src.endsWith('1_X.jpg')) {
                element.remove();
            }
        });
        let $desktopImg = $('.image-container').find('.images-hover');
        Array.prototype.forEach.call($desktopImg, element => {
            if (element.children.length === 3) {
                element.children[0].className += ' let-hover';
            }
        });
    });
}

// scroll to the pid selected
/**
 * Scroll to the product
 */
function scrollToPid(pid) {
    var element = $('[data-pid="' + pid + '"]');
    if (element.length > 0) {
        element.get(0).scrollIntoView({ behavior: 'instant', block: 'end' });
    }
}

// scroll Position
/**
 * Stock the scroll Position of the user
 */
function scrollPos() {
    $('body').on('click', '[data-pid]', function () {
        // Récupération de la valeur de l'attribut data-pid
        var pid = $(this).data('pid');
        // Enregistrement de la valeur de data-pid
        localStorage.setItem('pid', pid);
    });

    $(window).on('load', function () {
        var pid = localStorage.getItem('pid');

        if (pid !== null) {
            // lazyloaded images stops calculating tile position. to make use of this feature we have to do it on the next tick of the browser
            setTimeout(function () {
                scrollToPid(pid);
                localStorage.removeItem('pid');
            }, 500);
        }
    });
}

/**
* Handles the sticky behavior of filter elements on the page using the Intersection Observer API.
* This function observes the visibility of the filter selector element and toggles the visibility
* and position of the sticky filter bar based on the intersection ratio.
*
* @function
* @returns {void}
*/
function handleStickyFilters() {
    let $filtersSelector = $('.js-filters-selector.js-filters-selector.display-refinements');
    let $stickyFilterBar = $('.sticky-filter-link');

    document.addEventListener('refinements_bar_hide', () => {
        $stickyFilterBar.removeClass('d-block');
        $($filtersSelector[0]).css('visibility', 'visible');
    });

    document.addEventListener('refinements_bar_display', () => {
        let siteHeader = document.querySelector('.site-header');
        const stickyNav = document.getElementById('navigation');
        // on ios devices there is a loading element delay, we need to wait for availability
        // for windows os we subtract 2px for top css property
        setTimeout(() => {
            $stickyFilterBar.css('top', window.app.isMobile() ? stickyNav.offsetHeight : siteHeader.offsetHeight - 2);
        }, 0);

        $stickyFilterBar.addClass('d-block');
        $($filtersSelector[0]).css('visibility', 'hidden');
    });
}

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('body').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            var refinementBar = $('.refinement-bar');
            refinementBar.siblings().attr('aria-hidden', true);
            refinementBar.closest('.row').siblings().attr('aria-hidden', true);
            refinementBar.closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            refinementBar.closest('.container.search-results').siblings().attr('aria-hidden', true);
            refinementBar.find('.close').focus();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('body').on('click', '.refinement-bar button.close, .modal-background', function () {
            var refinementBar = $('.refinement-bar');
            $('.refinement-bar, .modal-background').hide();
            refinementBar.siblings().attr('aria-hidden', false);
            refinementBar.closest('.row').siblings().attr('aria-hidden', false);
            refinementBar.closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            refinementBar.closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            var refinementBar = $('.refinement-bar');
            $('.refinement-bar, .modal-background').hide();
            refinementBar.siblings().attr('aria-hidden', false);
            refinementBar.closest('.row').siblings().attr('aria-hidden', false);
            refinementBar.closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            refinementBar.closest('.container.search-results').siblings().attr('aria-hidden', false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('body').on('click', '[name=sort-order] li button.sort-btn', function (e) {
            var url = $(this).data('href');
            var current = this;
            e.preventDefault();
            $.spinner().start();
            $(this).trigger('search:sort', $(this).data('href'));
            $.ajax({
                url: url,
                data: { selectedUrl: url },
                method: 'GET',
                success: function (response) {
                    window.filterUrl = url;

                    // cache sorted grid results
                    if (window.$filterResponse && window.$filterResponse.length) {
                        window.$filterResponse.find('.product-grid').html(response);
                    } else {
                        window.$filterResponse = $('html').clone();
                        window.$filterResponse.find('.product-grid').html(response);
                    }

                    activateSorting(current);
                    updateSortingRuleURL(current);
                    hoverImage();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('body').on(
            'click',
            '.refinements li button.filter-btn, .mobile-refinements-container button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $(this).trigger('search:filter', e);
                let url = $(this).data('href');
                $.ajax({
                    url: url,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $(this).data('href')
                    },
                    method: 'GET',
                    success: function (response) {
                        window.filterUrl = url;
                        window.$filterResponse = $(response);
                        parseResults(response, true);
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        );
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },
    showMore: showMore,
    showLess: showLess,

    productRecommendations: recommendationsLogic.initRecommandationLogic,

    init: function () {
        // 0013935: [Correction Tracking app mobile] Intégration de méthode js spécfique pour faire remonter le tracking via le SDK de Firebase
        $(document).ready(function () {
            $('body').trigger('plp:init');
            handleStickyFilters();
        });
        // 0013212: [WEBPERF] Product Tile : Remove Double image markup
        hoverImage();
        scrollPos();

        $('.collapse-toggle').click(function () {
            var elementId = $(this).data('id');
            $('#' + elementId).slideToggle();
        });
        $('body').on('close-popup', function (e, response) {
            let target = response.target;
            $('#' + target).hide();
            $('div.refinement').removeClass('active');
            $('.icon-chevron-up').removeClass('icon-chevron-up').addClass('icon-chevron-down');
            $('[aria-expanded="true"]').attr('aria-expanded', 'false');
        });
        $('body').on('open-popup', function (e, response) {
            var target = response.target;
            $('#' + target).show();
        });

        $('body').on('click', '.btn-close, .btn-refine', function () {
            // update grid only if apply all clicked then close the popup, close popup directly on the click of close button
            if ($(this).hasClass('btn-refine')) {
                let url = window.filterUrl;
                if (window.$filterResponse && window.$filterResponse.length) {
                    $.spinner().start();
                    parseResults(window.$filterResponse);
                    toggleResetFilters();
                    $.spinner().stop();
                }
                if (url) {
                    // update history only filters are confirmed
                    updateUrlParams(url);
                }
            }
            hoverImage();
            $('#refinements-popup').css('display', 'none');
            $(this).closest('.popup').trigger('close-popup', { target: $(this).attr('aria-controls') });
        });
        $('body').on('click', '.btn-refine', function () {
            scrollAnimate();
        });
        $('body').on('click', '.js-trigger-filter-popin', function () {
            var target = 'refinements-popup';
            $('body').trigger('open-popup', { target: target });
        });
        $('body').on('click', '.image-container .link-cbo', function (e) {
            e.stopPropagation();
            var encodedUrl = $(this).attr('data-cbo');
            var showMoreUrl = decodeURIComponent(window.atob(encodedUrl));
            window.location.href = showMoreUrl;
        });
        $('body').on('click', '.link-cbo', function (e) {
            e.stopPropagation();
            let encodedUrl = $(this).attr('data-cbo');
            let showMoreUrl = decodeURIComponent(window.atob(encodedUrl));
            window.location.href = showMoreUrl;
        });
    },
    handleReviewStarsPLP: function () {
        $('.tile-Infos > .trustville-product-widget-small').each(function () {
            $(this).on('click', function (e) {
                e.preventDefault();
                window.location.href = $(this).closest('.product-tile').find('a').attr('href');
            });
        });
    }
};
